import React from 'react';

// tslint:disable max-line-length
const CChoosePart1Munch: React.FC = () => (
  <>
    <h5>Choosing part 1</h5>
    <p>Right. It’s time to get out there. Let that person be your filter as you walk. The first thing you choose – why is it right for this person? Is it going to trigger a memory of time you spent together?  Does it shine out in their favourite colour? Or you are you choosing this object for the story it comes with already? It’s this person, these objects, and you.  Bring them together.</p>
  </>
);

export {
  CChoosePart1Munch,
};
